import React from 'react'
import { RiDeleteBinLine } from "react-icons/ri";

const StatusModal = ({ onSubmit, closeModal, isOpen, title }) => {
    if (!isOpen) return null;

    return (
        <div>
            <div>
                <div
                    className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm"
                >
                    <div className="bg-white w-11/12 sm:w-1/2 lg:w-1/4 rounded-lg shadow-lg p-6 text-center">
                        <div className="flex justify-center items-center">
                            <RiDeleteBinLine className='text-xl text-white bg-red-500 p-3 rounded-full w-12 h-12' />
                        </div>
                        <h2 className="text-2xl font-semibold text-gray-800">{title}</h2>
                        <p className="text-black mt-3 mb-3">
                            Are you sure you want to update the status?
                        </p>
                        <p className="text-gray-500 mb-6">
                            Click To Submit To Chnage Status
                        </p>
                        <div className="flex justify-center space-x-4">
                            <button
                                onClick={closeModal}
                                className="px-6 py-2 text-[#ED3636] border border-[#ED3636] rounded-lg hover:bg-[#ED3636] hover:text-white transition"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={onSubmit}
                                className="px-6 py-2 text-white bg-[#ED3636] rounded-lg hover:bg-red-600 transition"
                            >
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default StatusModal